import { SupervisoryInstitution } from '../../../../../../../api/types/settings/studies/supervisory-institution';
import { Major } from '../../../../../../../api/types/settings/studies/major';
import { AbstractCourse } from '../../../../../../../api/types/settings/studies/abstract-course';
import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../../stores/settings-stores';

export const createNewAbstractCourseOperation = async (
  programName: string,
  programYears: number,
  supervisoryInstitutionList: SupervisoryInstitution[],
  majors: Major[],
  abstractCourses: AbstractCourse[] | null,
  setLoading: (isLoading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (!programName || programName.length < 3) {
      toast.warn('על שם התוכנית להיות למעלה משלושה תווים');
      return;
    }
    if (programYears === 0) {
      toast.warn('יש להזין מספר שנים');
      return;
    }

    const majorsId: number[] = majors.map((majorItem) => majorItem.id);
    const institutionId: number[] = supervisoryInstitutionList.map(
      (institutionItem) => institutionItem.id,
    );

    const courseId: number[] =
      abstractCourses?.map((abstractCourseItem) => abstractCourseItem.id) ?? [];
    const existingAbstractProgram = globalSettingsStores.abstractProgram.find(
      (item) => item.programName === programName,
    );
    if (existingAbstractProgram) {
      toast.warn('שם תוכנית לימודים כבר קיים במערכת');
      return;
    }

    setLoading(true);
    // TODO API call

    const res = await appApi.createAbstractProgram({
      programName: programName,
      programYears: programYears,
      majorsId: majorsId,
      institutionId: institutionId,
      abstractCoursesId: courseId,
    });
    globalSettingsStores.abstractProgram.push(res.data.body);
    toast.success(`יצירת התכונית התבצעה בהצלחה`);
    setLoading(false);
    closeDialog();
  } catch (e) {
    console.log(
      `Create new abstract course is failed with programName: ${programName} programYears: ${programYears} supervisoryInstitutionList: ${supervisoryInstitutionList} majors: ${majors} abstractCourses: ${abstractCourses}`,
    );
    toast.error(`יצירת התוכנית הטיפוסית ${programName} נכשלה`);
  }
};
